
export default new class sacrificePlaceTypeStatus
{
    MemorialHall = 0;// 纪念馆
    MourningHall = 1; // 灵堂
    Cemetery = 2;// 墓园
}








